import { ReactComponent as PostIcon } from 'assets/icons/post16.svg'
import cx from 'classnames'
import { ChangeEventHandler, KeyboardEventHandler, useCallback } from 'react'

import Styles from './QueryOrLink.module.scss'

import { ReactComponent as SearchIcon } from 'assets/icons/search__16.svg'
import { IconButton } from 'components/IconButton/IconButton'

export const QueryOrLink = ({
  query,
  linkError,
  onChange,
  onKeyDown,
  showUpdateButton = false,
  inputId,
  onSubmit,
}: {
  query: string
  linkError: boolean
  inputId?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  onKeyDown: KeyboardEventHandler<HTMLInputElement>
  onSubmit?: () => void
  showUpdateButton?: boolean
}) => {
  const placeholder = 'Search for doc, person, or enter in a link'
  const empty = query === ''
  const spacerText = empty ? placeholder : query

  const focusInput = useCallback((inputElement: HTMLInputElement) => {
    if (inputElement) {
      setTimeout(() => {
        inputElement.focus()
        inputElement.select()
      }, 50)
    }
  }, [])

  return (
    <>
      <div className={cx(Styles.linkModalInputWrapper, { [Styles.inputError]: linkError })}>
        <div className={Styles.linkModalResizingInput}>
          {empty ? (
            <div className={Styles.emptyState}>
              <SearchIcon className={Styles.linkModalInputIcon} />
              {placeholder}
            </div>
          ) : (
            <span className={cx(Styles.linkModalHiddenText, { [Styles.textWithUpdateButton]: showUpdateButton })}>
              {spacerText}
            </span>
          )}

          <span className={Styles.visibleWrapper}>
            <input
              key="modalLink"
              ref={focusInput}
              className={cx(Styles.linkModalInput, {
                [Styles.linkModalInputWithButton]: showUpdateButton,
                [Styles.linkModalInputEmptyState]: empty,
                [Styles.errorBackground]: linkError,
              })}
              type="text"
              enterKeyHint="done"
              value={query}
              autoFocus
              id={inputId}
              onChange={onChange}
              onKeyDown={onKeyDown}
            />
            {onSubmit !== undefined && query !== '' && (
              <IconButton variant="primary" title="Save" icon={PostIcon} onPress={onSubmit} />
            )}
          </span>
        </div>
      </div>

      {linkError && <div className={Styles.inputErrorMessage}>This doesn’t appear to be valid URL</div>}
    </>
  )
}
